<template>
  <div class="h-screen">
    <div class="h-full relative">
      <base-picture
        class="full absolute"
        fit="cover"
        height="531"
        :props-img="{ class: 'w-full', style: 'object-position: top right', role: 'presentation' }"
        :src="{
          sm: 'https://assets.timberland.com/image/upload/q_auto,f_auto/v1723688110/TBL-500-error-320',
          md: 'https://assets.timberland.com/image/upload/q_auto,f_auto/v1723688110/TBL-500-error-768',
          lg: 'https://assets.timberland.com/image/upload/q_auto,f_auto/v1723688110/TBL-500-error-1024',
        }"
        width="320"
      />

      <div class="absolute-0">
        <div class="c-white pt-16 container">
          <p class="text-xl pb-8 italic">
            {{ $t.maintenance.ERR5xx.seoText }}
          </p>
          <h1 class="display-3 pr-4 f-col">
            <span>{{ $t.maintenance.ERR5xx.title }}</span>
            <span>{{ $t.maintenance.ERR5xx.subtitle }}</span>
          </h1>
          <p class="pb-12 pt-4 lg:pt-6 md:(pb-8 max-w-3/5)">
            {{ $t.maintenance.ERR5xx.message }}
          </p>
          <vf-button class="<md:w-full" size="md" @click="clearError">
            {{ $t.maintenance.ERR5xx.cta }}
          </vf-button>
        </div>
      </div>
    </div>
  </div>
</template>
